
/*
 *
 * Date: 2025
 * Description: List user form component for adding or editing items, even handling deleting items or the whole list..
 * Author: Philippe Leroux @SKITSC
 *
 */

import { Box , Paper , Typography , Grid , TextField , Button } from "@mui/material";
import { ReactElement } from "react";
import { i_user_list_form } from "../../interfaces/display.interfaces";


const ListUserForm = ( props : i_user_list_form ) : ReactElement => {

    const F = props.form
    const handleField = ( event : React.ChangeEvent<HTMLInputElement>) => {
        props.setForm({...F, [event.target.name] : event.target.value})
    }
    return (
        <Box>
            <Paper elevation={5} sx={{ padding : 3 , maxWidth : '1200px' , width : '100%' ,  marginLeft : 'auto' , marginRight: 'auto' , marginTop : '2vh'}}>
                <Typography sx={{ textAlign : 'center' , textDecoration : 'underline', marginBottom : '2vh'}} variant="h5"> Summary of the order</Typography>
                <Grid container spacing={4}>
                    <Grid size={3}>
                        <Typography variant="h6">PO Number : </Typography>
                    </Grid>
                    <Grid size={9}>
                        <TextField value={F.po} onChange={handleField} name={'po'}></TextField>
                    </Grid>
                    <Grid size={3} sx={{}}>
                        <Typography variant="h6">Comments :</Typography>
                    </Grid>
                    <Grid size={9}>
                        <TextField multiline rows={3} value={F.comment} onChange={handleField} name={'comment'} fullWidth/>
                    </Grid>
                    <Grid size={12}>
                        <Button sx={{ marginLeft : 'auto' , marginRight : 'auto' , display : 'block'}} variant="contained" loading={props.loading} onClick={() => props.callback()}>Submit</Button>
                    </Grid>
                </Grid>
            </Paper>
            
        </Box>
    )
}


export default ListUserForm;